export class ConfirmUser {
  //   name: string;
  //   email: string;
  //   icNumber: string;
  //   address: string;
  //   postcode: string;
  //   state: string;

  constructor(
    public id: string,
    public name?: string,
    public email?: string,
    public icNumber?: string,
    public contactNumber?: string,
    public address?: string,
    public postcode?: string,
    public state?: string
  ) {}
}
